import { render, staticRenderFns } from "./VLibrarySearchField.vue?vue&type=template&id=f8ade7d4&"
import script from "./VLibrarySearchField.vue?vue&type=script&lang=js&"
export * from "./VLibrarySearchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports